// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"d1d4740e","4819":"d1d4740e","7663":"a466293d"}[chunkId] + ".chunk.css";
};